import Vue from 'vue';
import Router from 'vue-router';
import store from './store.js';
import Home from './views/Home.vue';
import About from './views/About.vue';
import Login from './components/Login.vue';
// import Secure from './components/Secure.vue';
import Avisos from './components/Avisos.vue';
import Contatos from './components/Contatos.vue';
import Usuarios from './components/usuarios/Usuarios.vue';
import UsuariosEditar from './components/usuarios/Editar.vue';
import Register from './components/Register.vue';
import Orcamentos from './components/orcamentos/Orcamentos.vue';
import NegocioOrcamentos from './components/orcamentos/NegocioOrcamentos.vue';
import NegocioOrcamentosPesquisar from './components/orcamentos/NegocioOrcamentosPesquisar.vue';
import NegocioOrcamentosDivisao from './components/orcamentos/NegocioOrcamentosDivisao.vue';
import NegocioOrcamentosDivisaoGerencial from './components/orcamentos/NegocioOrcamentosDivisaoGerencial.vue';
import NegocioOrcamentosRevisaoFator from './components/orcamentos/NegocioOrcamentosRevisaoFator.vue';
import NegocioCustoMaoObra from './components/orcamentos/NegocioCustoMaoObra.vue';
import cadOrcamento from './components/orcamentos/Cadastro.vue';
import visOrcamento from './components/orcamentos/Visualizar.vue';
import Termometria from './components/termometria/Termometria.vue';
import TermometriaGerencial from './components/termometria/TermometriaGerencial.vue';
import TermometriaCadastro from './components/termometria/TermometriaCadastro.vue';
import termometriaCadastroNovaVersao from './components/termometria/TermometriaCadastroNovaVersao.vue';
import termometriaItens from './components/termometria/TermometriaItens.vue';
import termometriaVisualizar from './components/termometria/TermometriaVisualizar.vue';
import gerarPropostaTermometria from './components/termometria/proposta/Proposta.vue';
import termometriaProdutosImportacao from './components/termometria/TermometriaProdutosImportacao.vue';
import termometriaProdutosImportacao2 from './components/termometria/TermometriaProdutosImportacao2.vue';
import termometriaProdutosImportacao3 from './components/termometria/TermometriaProdutosImportacao3.vue';
import termometriaProdutos from './components/termometria/TermometriaProdutos.vue';
import TermometriaOrcamentoCriar from './components/termometria/TermometriaOrcamentoCriar.vue';
import TermometriaProdutoListaPrecos from './components/termometria/TermometriaProdutoListaPrecos.vue';
import TermometriaManutencao from './components/termometria/TermometriaManutencao.vue';
import TermometriaCliente from './components/termometria/TermometriaCliente.vue';
import TermometriaProdutoLista from './components/termometria/TermometriaProdutoLista.vue';
//import editOrcamento from './components/orcamentos/Editar.vue';
import configuracoes from './components/configuracoes/Configuracoes.vue';
import Configuracoes2 from './components/Configuracoes2.vue';
import ConfiguracoesFabricantes from './components/ConfiguracoesFabricantes.vue';
import teste from './components/teste/Teste.vue';
import gerarProposta from './components/orcamentos/proposta/Proposta.vue';
//import gerarProposta from './components/orcamentos/proposta/Proposta.vue';

Vue.use(Router)

let router = new Router({
    linkActiveClass: 'is-active',
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'home',
        component: Home,
        meta: { 
          requiresAuth: true
        }
      },
      {
        path: '/login',
        name: 'login',
        component: Login
      },
      //////////////////////////////////////////////////////
      // ATIVEI PARA VER SE POSSO FAZER UM REGISTRO
      //////////////////////////////////////////////////////
      {
        path: '/register',
        name: 'register',
        component: Register
      },
      //////////////////////////////////////////////////////
      // {
      //   path: '/secure',
      //   name: 'secure',
      //   component: Secure,
      //   meta: { 
      //     requiresAuth: true
      //   }
      // },
      {
        path: '/avisos',
        name: 'avisos',
        component: Avisos,
        meta: { 
          requiresAuth: true
        }
      },
      {
        path: '/usuarios',
        name: 'usuarios',
        component: Usuarios,
        meta: { 
          requiresAuth: true
        }
      },       
      {
        path: '/edituser/:id',
        name: 'edituser',
        component: UsuariosEditar,
        meta: { 
          requiresAuth: true
        }
      },       
      {
        path: '/contatos',
        name: 'contatos',
        component: Contatos,
        meta: { 
          requiresAuth: true
        }
      },
      {
        path: '/orcamentos',
        name: 'orcamentos',
        component: Orcamentos,
        meta: { 
          requiresAuth: true
        }
      },   
      {
        path: '/cadOrcamento',
        name: 'cadOrcamento',
        component: cadOrcamento,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/cadOrcamento/:id',
        name: 'cadNovaVersao',
        component: cadOrcamento,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/visOrcamento/:id',
        name: 'visOrcamento',
        component: visOrcamento,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/orcamentos/gerarProposta/:id',
        name: 'gerarProposta',
        component: gerarProposta,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/negocio-orcamentos',
        name: 'negocio-orcamentos',
        component: NegocioOrcamentos,
        meta: { 
          requiresAuth: true
        }
      },   
      {
        path: '/orcamentos/pesquisar',
        name: 'NegocioOrcamentosPesquisar',
        component: NegocioOrcamentosPesquisar,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/orcamento/divisao/negocio/:id',
        name: 'NegocioOrcamentosDivisao',
        component: NegocioOrcamentosDivisao,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/orcamento/divisao/negocio/gerencial/:id',
        name: 'NegocioOrcamentosDivisaoGerencial',
        component: NegocioOrcamentosDivisaoGerencial,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/orcamento/divisao/negocio/revisao/itens/:id',
        name: 'NegocioOrcamentosRevisaoFator',
        component: NegocioOrcamentosRevisaoFator,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/termometria',
        name: 'termometria',
        component: Termometria,
        meta: { 
          requiresAuth: true
        }
      },   
      {
        path: '/termometria/gerencial',
        name: 'termometriaGerencial',
        component: TermometriaGerencial,
        meta: { 
          requiresAuth: true
        }
      },   
      {
        path: '/termometria/cadastro',
        name: 'termometriaCadastro',
        component: TermometriaCadastro,
        meta: { 
          requiresAuth: true
        }
      },   
      {
        path: '/termometria/cliente',
        name: 'termometriaCliente',
        component: TermometriaCliente,
        meta: { 
          requiresAuth: true
        }
      },   
      {
        path: '/termometria/produto/lista',
        name: 'termometriaProdutoLista',
        component: TermometriaProdutoLista,
        meta: { 
          requiresAuth: true
        }
      },   
      {
        path: '/termometria/produto/lista/preco/:id',
        name: 'termometriaProdutoListaPrecos',
        component: TermometriaProdutoListaPrecos,
        meta: { 
          requiresAuth: true
        }
      },   
      {
        path: '/termometria/manutencao',
        name: 'termometriaManutencao',
        component: TermometriaManutencao,
        meta: { 
          requiresAuth: true
        }
      },   
      // {
      //   path: '/cadTermometria',
      //   name: 'cadTermometria',
      //   component: cadTermometria,
      //   meta: { 
      //     requiresAuth: true
      //   }
      // }, 
      {
        path: '/termometria/itens/:id',
        name: 'termometria/itens',
        component: termometriaItens,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/termometria/produtos/importacao',
        name: 'termometria/produtos/importacao',
        component: termometriaProdutosImportacao,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/termometria/produtos/importacao2',
        name: 'termometria/produtos/importacao2',
        component: termometriaProdutosImportacao2,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/termometria/produtos/importacao3',
        name: 'termometria/produtos/importacao3',
        component: termometriaProdutosImportacao3,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/termometria/produtos',
        name: 'termometria/produtos',
        component: termometriaProdutos,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/termometria/nova-versao/:id',
        name: 'termometriaCadastroNovaVersao',
        component: termometriaCadastroNovaVersao,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/termometria/visualizar/:id',
        name: 'termometria/visualizar',
        component: termometriaVisualizar,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/termometria/gerarPropostaTermometria/:id',
        name: 'gerarPropostaTermometria',
        component: gerarPropostaTermometria,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/termometria/orcamento/criar',
        name: 'termometria/orcamento/criar',
        component: TermometriaOrcamentoCriar,
        meta: { 
          requiresAuth: true
        }
      }, 
      {
        path: '/termometria/orcamento/criar/:id',
        name: 'termometria-orcamento-criar',
        component: TermometriaOrcamentoCriar,
        props: true,
      },
      {
        path: '/termometria/orcamento/duplicar/:id',
        name: 'termometria-orcamento-duplicar',
        component: TermometriaOrcamentoCriar,
        props: true,
      },
      // {
      //   path: '/editOrcamento/:id',
      //   name: 'editOrcamento',
      //   component: editOrcamento,
      //   meta: { 
      //     requiresAuth: true
      //   }
      // }, 
      {
        path: '/configuracoes',
        name: 'configuracoes',
        component: configuracoes,
        meta: { 
          requiresAuth: true
        }
      },                     
      {
        path: '/configuracoes-2',
        name: 'Configuracoes2',
        component: Configuracoes2,
        meta: { 
          requiresAuth: true
        }
      },                     
      {
        path: '/configuracoes-fabricantes',
        name: 'configuracoesFabricantes',
        component: ConfiguracoesFabricantes,
        meta: { 
          requiresAuth: true
        }
      },                     
      {
        path: '/negocio-custo-mao-obra',
        name: 'negocioCustoMaoObra',
        component: NegocioCustoMaoObra,
        meta: { 
          requiresAuth: true
        }
      },                     
      {
        path: '/teste',
        name: 'teste',
        component: teste,
        meta: { 
          requiresAuth: true
        }
      },                     
      {
        path: '/about',
        name: 'about',
        component: About
      },
    ]
  })
  
  export default router

  router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
      if (store.getters.isLoggedIn) {
        next()
        return
      }
      next('/login') 
    } else {
      next() 
    }
  })